// freshtoken
export const FreshToken = 'quan_fresh_token';
// accesstoken
export const AccessToken = 'quan_access_token';